export const mdsStyleClasses = {
    standardTextField: 'MdsStandardTextField',
    notchedTextField: 'MdsNotchedTextField',
};
